import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Ajouter ces importations :
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxPaginationModule } from 'ngx-pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		AlertModule.forRoot(),
		BsDatepickerModule.forRoot(),
		BsDropdownModule.forRoot(),
		ModalModule.forRoot(),
		PopoverModule.forRoot(),
		NgxPaginationModule, // pour la pagination des tableaux
		TabsModule.forRoot()
	],
	exports: [
		AlertModule,
		BsDatepickerModule,
		BsDropdownModule,
		ModalModule,
		PopoverModule,
		NgxPaginationModule,
		TabsModule
	]
})
export class NgxBootstrapModule {}
